import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../../styles/LeagueList.css';
import { useAdminData } from '../../../contexts/AdminDataContext';

const LeagueList = () => {
    const { allLeagues, leaguesLoading } = useAdminData();
    const [searchQuery, setSearchQuery] = useState('');

    // Filter leagues based on search query
    const filteredLeagues = allLeagues.filter(league => {
        if (searchQuery) {
            const query = searchQuery.toLowerCase();
            return league.name.toLowerCase().startsWith(query);
        }
        return true;
    });

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className="league-list-page">
            <div className="page-header">
                <h1>Leagues</h1>
                <Link to="/admin/leagues/create" className="create-button">
                    Create New League
                </Link>
            </div>

            <div className="search-box">
                <input
                    type="text"
                    placeholder="Search leagues..."
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="search-input"
                />
            </div>

            {leaguesLoading ? (
                <div className="loading-spinner"></div>
            ) : filteredLeagues.length === 0 ? (
                <div className="no-results">No leagues found</div>
            ) : (
                <div className="leagues-grid">
                    {filteredLeagues.map(league => (
                        <div key={league.id} className="league-card">
                            <div className="league-card-content">
                                <img
                                    src={league.image}
                                    alt={league.name}
                                    className="league-logo"
                                    onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
                                />
                                <h3>{league.name}</h3>
                            </div>
                            <div className="league-card-actions">
                                <Link to={`/admin/leagues/edit/${league.id}`} className="league-edit-button">
                                    Edit
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LeagueList;
